<main>
    <div class="content">
        <div class="main-image">
            <img [src]="baseApiUrl + '/' + post.files[0].file_url" alt="">
            <!-- <p class="image-text">{{ 'nonghyup_bank.HEADER' | translate }}</p> -->
        </div>
        <div class="paragraph">
            <div class="title">
                <h2>{{ isEnglish() ? post.title : post.title_kh }}</h2>
            </div>
            <div class="desc">
                <p *ngIf="isEnglish()">{{ post.description | stripHtmlAndConvert }}</p>
                <p *ngIf="isKhmer()">{{ post.description_kh | stripHtmlAndConvert }}</p>
            </div>
            <div class="gallery">
                <div class="row">
                    <div class="col">
                        <img [src]="baseApiUrl + '/' + post.files[0].file_url" alt="" (click)="openPreview(baseApiUrl + '/' + post.files[0].file_url)">
                    </div>
                </div>
                 <div class="row">
                    <div class="col-6" *ngFor="let file of post.files">
                        <img [src]="baseApiUrl + '/' + file.file_url" alt="" (click)="openPreview(baseApiUrl + '/' + file.file_url)" >
                    </div>
                </div>
            </div>

        <!-- Image Preview Popup -->
        <app-image-preview
            [imageUrl]="previewImage"
            (close)="closePreview()"
        ></app-image-preview>

        </div>
    </div>
    <div class="bottom-content">
        <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
        <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
    </div>
</main>